module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog-content', [_c('p', [_vm._v("Collaborators")]), _vm._v(" "), _c('md-list', {
    staticClass: "md-double-line"
  }, [(_vm.owner) ? _c('md-list-item', [_c('md-avatar', [_c('img', {
    attrs: {
      "src": _vm.owner.profile_picture,
      "alt": "Owner Profile"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v(_vm._s(_vm.owner.username))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.owner.email))]), _vm._v(" "), _c('span', [_vm._v("Project Owner")])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.project.collaborators), function(collab, index) {
    return _c('collaborator', {
      key: collab.uid || index,
      attrs: {
        "user": collab.uid && _vm.userByUID(collab.uid) || collab,
        "collaborator": collab,
        "collabUser": null
      },
      on: {
        "removeCollaborator": _vm.removeCollaborator
      }
    })
  }), _vm._v(" "), _c('invite', {
    attrs: {
      "project": _vm.project
    },
    on: {
      "addCollaborator": _vm.addCollaborator
    }
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-002b9733","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/create-project/collaborators.vue
// module id = 1195
// module chunks = 21